// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3kSZJ","open":"open___dNxZo","tableTitle":"tableTitle___2YD30","title":"title___1fc9Y"};